import { render } from "./QuestionSectionCreateEditFormComponent.vue?vue&type=template&id=4ef7310c&scoped=true"
import script from "./QuestionSectionCreateEditFormComponent.vue?vue&type=script&lang=js"
export * from "./QuestionSectionCreateEditFormComponent.vue?vue&type=script&lang=js"

import "./QuestionSectionCreateEditFormComponent.vue?vue&type=style&index=0&id=4ef7310c&scoped=true&lang=css"

import exportComponent from "/tmp/build_905a1b4c/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ef7310c"]])

export default __exports__